import { formatAppCode } from "@/v2-backoffice-client/usage/usage.constants"
import UsageFilterChips from "@/v2-backoffice-client/usage/UsageFilterChips"

export type UsageAppFilterChipsProps = {
  /** App codes present in the data, chip order. */
  apps: string[]
  /** Selected app; null = all apps. */
  value: string | null
  onChange(value: string | null): void
  className?: string
}

// App filter for the activity sections (chart, area breakdown, history).
// Only rendered when more than one product contributed data — a single-app
// user/scope has nothing to filter.
function UsageAppFilterChips(props: UsageAppFilterChipsProps) {
  const { apps, value, onChange, className } = props

  if (apps.length < 2) return null

  return (
    <UsageFilterChips
      options={[
        { label: "All apps", value: null },
        ...apps.map((app) => ({ label: formatAppCode(app), value: app })),
      ]}
      value={value}
      onChange={onChange}
      className={className}
    />
  )
}

export default UsageAppFilterChips
